module.exports = __webpack_public_path__ + "static/media/kyle-hughes_1.ed350e86.png";